import { useState, useCallback } from 'react';
import PropertiesAPI from '../PropertiesAPI';

export const FETCH_COMPANIES_ERROR =
  'Unable to fetch companies. Please try again later.';

export const TRANSFER_PROPERTY_ERROR =
  'Unable to transfer property. Please try again later.';

const useTransferProperty = ({ transferProperty }) => {
  const [companies, setCompanies] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchCompanies = useCallback(async () => {
    setIsLoading(true);
    try {
      const companies = await PropertiesAPI.getCompanies();
      setCompanies(companies);
    } catch {
      setErrorMessage(FETCH_COMPANIES_ERROR);
    }
    setIsLoading(false);
  }, []);

  const handleTransferProperty = async ({
    leasingTeamPublicId,
    managerUsername,
  }) => {
    setIsLoading(true);
    try {
      await transferProperty(leasingTeamPublicId, managerUsername);
    } catch {
      setErrorMessage(TRANSFER_PROPERTY_ERROR);
    }
    setIsLoading(false);
  };

  return {
    companies,
    errorMessage,
    fetchCompanies,
    isLoading,
    setErrorMessage,
    setIsLoading,
    handleTransferProperty,
  };
};

export default useTransferProperty;
